import React from 'react';

// SVG icons only for the 10 categories shown in the user's screenshots.
// Returns null for all others so callers fall back to their original emoji/image.
const icons = {
    entrance: (
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="8" y="10" width="48" height="46" rx="4" fill="#C8860A" opacity="0.25" />
            <rect x="10" y="14" width="18" height="36" rx="3" fill="#E8A020" opacity="0.9" />
            <rect x="30" y="14" width="18" height="36" rx="3" fill="#C8860A" opacity="0.9" />
            <ellipse cx="32" cy="14" rx="20" ry="8" fill="#F0C060" opacity="0.7" />
            <rect x="29.5" y="5" width="5" height="14" rx="1.5" fill="#fff" opacity="0.95" />
            <rect x="24" y="10" width="16" height="4" rx="1.5" fill="#fff" opacity="0.95" />
            <circle cx="28" cy="32" r="2" fill="#fff" opacity="0.8" />
            <circle cx="36" cy="32" r="2" fill="#fff" opacity="0.8" />
            <rect x="6" y="50" width="52" height="4" rx="2" fill="#E8A020" opacity="0.5" />
            <rect x="2" y="54" width="60" height="4" rx="2" fill="#C8860A" opacity="0.4" />
        </svg>
    ),

    responsorial: (
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="32" cy="38" rx="26" ry="18" fill="#E8A020" opacity="0.15" />
            <path d="M8 14 Q18 10 28 14 L28 52 Q18 48 8 52 Z" fill="#F5D990" opacity="0.9" />
            <path d="M36 14 Q46 10 56 14 L56 52 Q46 48 36 52 Z" fill="#F0C060" opacity="0.9" />
            <rect x="27" y="12" width="10" height="42" rx="3" fill="#C8860A" opacity="0.8" />
            <rect x="11" y="22" width="13" height="2" rx="1" fill="#C8860A" opacity="0.6" />
            <rect x="11" y="27" width="11" height="2" rx="1" fill="#C8860A" opacity="0.5" />
            <rect x="11" y="32" width="13" height="2" rx="1" fill="#C8860A" opacity="0.6" />
            <rect x="11" y="37" width="9" height="2" rx="1" fill="#C8860A" opacity="0.5" />
            <rect x="40" y="22" width="13" height="2" rx="1" fill="#C8860A" opacity="0.6" />
            <rect x="40" y="27" width="11" height="2" rx="1" fill="#C8860A" opacity="0.5" />
            <rect x="40" y="32" width="13" height="2" rx="1" fill="#C8860A" opacity="0.6" />
            <rect x="40" y="37" width="9" height="2" rx="1" fill="#C8860A" opacity="0.5" />
            <rect x="30.5" y="6" width="3" height="10" rx="1" fill="#E8A020" />
            <rect x="28" y="10" width="8" height="2.5" rx="1" fill="#E8A020" />
        </svg>
    ),

    worship: (
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="32" cy="28" rx="20" ry="18" fill="#F0C060" opacity="0.15" />
            <path d="M12 48 Q10 38 14 28 Q16 22 20 20 Q22 19 22 22 L22 30 Q22 28 24 26 Q26 24 27 27 L27 32 Q27 30 29 29 Q31 28 31 31 L31 38 Q33 34 35 36 L35 44 Q32 50 26 52 Z" fill="#F5D990" opacity="0.9" />
            <path d="M52 48 Q54 38 50 28 Q48 22 44 20 Q42 19 42 22 L42 30 Q42 28 40 26 Q38 24 37 27 L37 32 Q37 30 35 29 Q33 28 33 31 L33 38 Q31 34 29 36 L29 44 Q32 50 38 52 Z" fill="#F5D990" opacity="0.9" />
            <polygon points="32,6 33.5,11 38,10 34.5,13 36,18 32,15 28,18 29.5,13 26,10 30.5,11" fill="#F0C060" opacity="0.95" />
        </svg>
    ),

    christmas: (
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <polygon points="32,6 48,28 40,28 52,44 42,44 54,60 10,60 22,44 12,44 24,28 16,28" fill="#2E7D32" opacity="0.9" />
            <rect x="27" y="56" width="10" height="8" rx="2" fill="#5D4037" opacity="0.9" />
            <circle cx="24" cy="36" r="3" fill="#E53935" opacity="0.9" />
            <circle cx="40" cy="36" r="3" fill="#F0C060" opacity="0.9" />
            <circle cx="32" cy="48" r="3" fill="#E53935" opacity="0.9" />
            <circle cx="22" cy="50" r="2.5" fill="#F0C060" opacity="0.8" />
            <circle cx="42" cy="50" r="2.5" fill="#E8A020" opacity="0.8" />
            <polygon points="32,2 33.5,7 38,6 34.5,9 36,14 32,11 28,14 29.5,9 26,6 30.5,7" fill="#F0C060" />
            <circle cx="29" cy="30" r="1.5" fill="#fff" opacity="0.7" />
            <circle cx="36" cy="34" r="1.5" fill="#fff" opacity="0.6" />
            <circle cx="32" cy="42" r="1" fill="#fff" opacity="0.7" />
        </svg>
    ),

    newyear: (
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, i) => (
                <line key={i} x1="32" y1="32"
                    x2={32 + 22 * Math.cos(angle * Math.PI / 180)}
                    y2={32 + 22 * Math.sin(angle * Math.PI / 180)}
                    stroke={i % 2 === 0 ? "#F0C060" : "#E8A020"}
                    strokeWidth="3" strokeLinecap="round" opacity="0.9" />
            ))}
            {[22, 67, 112, 157, 202, 247, 292, 337].map((angle, i) => (
                <circle key={i}
                    cx={32 + 24 * Math.cos(angle * Math.PI / 180)}
                    cy={32 + 24 * Math.sin(angle * Math.PI / 180)}
                    r="2.5" fill={i % 2 === 0 ? "#F0C060" : "#E53935"} opacity="0.9" />
            ))}
            <polygon points="32,22 33.8,28 40,28 34.9,31.8 36.7,38 32,34 27.3,38 29.1,31.8 24,28 30.2,28" fill="#F0C060" opacity="0.95" />
            <circle cx="32" cy="32" r="5" fill="#fff" opacity="0.3" />
        </svg>
    ),

    easter: (
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            {[0, 30, 60, 90, 120, 150].map((angle, i) => (
                <line key={i}
                    x1={32 + 14 * Math.cos((angle - 90) * Math.PI / 180)}
                    y1={36 + 14 * Math.sin((angle - 90) * Math.PI / 180)}
                    x2={32 + 26 * Math.cos((angle - 90) * Math.PI / 180)}
                    y2={36 + 26 * Math.sin((angle - 90) * Math.PI / 180)}
                    stroke="#F0C060" strokeWidth="2.5" strokeLinecap="round" opacity="0.7" />
            ))}
            <ellipse cx="32" cy="52" rx="28" ry="10" fill="#4CAF50" opacity="0.5" />
            <path d="M14 38 A18 18 0 0 1 50 38 Z" fill="#F0C060" opacity="0.3" />
            <path d="M16 38 A16 16 0 0 1 48 38 Z" fill="#F0C060" opacity="0.7" />
            <line x1="10" y1="38" x2="54" y2="38" stroke="#E8A020" strokeWidth="2" opacity="0.6" />
            <rect x="28.5" y="14" width="7" height="30" rx="3.5" fill="#fff" opacity="0.95" />
            <rect x="18" y="22" width="28" height="7" rx="3.5" fill="#fff" opacity="0.95" />
            <rect x="30" y="14" width="2" height="30" rx="1" fill="#F0C060" opacity="0.4" />
        </svg>
    ),

    lent: (
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="32" cy="32" rx="26" ry="26" fill="#6A0DAD" opacity="0.1" />
            <rect x="27" y="6" width="10" height="52" rx="5" fill="#6A0DAD" opacity="0.8" />
            <rect x="10" y="18" width="44" height="10" rx="5" fill="#6A0DAD" opacity="0.8" />
            <rect x="29" y="6" width="3" height="52" rx="1.5" fill="#fff" opacity="0.15" />
            <rect x="10" y="20" width="44" height="3" rx="1.5" fill="#fff" opacity="0.15" />
            <circle cx="32" cy="32" r="14" stroke="#8B4513" strokeWidth="2.5" fill="none" strokeDasharray="4 3" opacity="0.8" />
            <polygon points="32,16 33.5,19 35,16" fill="#8B4513" opacity="0.7" />
            <polygon points="46,32 43,33.5 46,35" fill="#8B4513" opacity="0.7" />
            <polygon points="32,48 30.5,45 33.5,45" fill="#8B4513" opacity="0.7" />
            <polygon points="18,32 21,30.5 21,33.5" fill="#8B4513" opacity="0.7" />
        </svg>
    ),

    wedding: (
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="22" cy="34" r="14" stroke="#E8A020" strokeWidth="4.5" fill="none" opacity="0.9" />
            <circle cx="42" cy="34" r="14" stroke="#F0C060" strokeWidth="4.5" fill="none" opacity="0.9" />
            <path d="M32 22 A14 14 0 0 0 32 46" stroke="#fff" strokeWidth="4.5" fill="none" opacity="0.2" />
            <circle cx="22" cy="20" r="3" fill="#E8A020" opacity="0.9" />
            <circle cx="42" cy="20" r="3" fill="#F0C060" opacity="0.9" />
            <circle cx="22" cy="20" r="1.5" fill="#fff" opacity="0.7" />
            <circle cx="42" cy="20" r="1.5" fill="#fff" opacity="0.7" />
            <rect x="29.5" y="4" width="5" height="12" rx="2.5" fill="#E8A020" opacity="0.9" />
            <rect x="24" y="8" width="16" height="4" rx="2" fill="#E8A020" opacity="0.9" />
        </svg>
    ),

    others: (
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="18" cy="46" rx="7" ry="5" fill="#E8A020" opacity="0.85" />
            <ellipse cx="38" cy="52" rx="7" ry="5" fill="#E8A020" opacity="0.85" />
            <rect x="24" y="12" width="3" height="36" rx="1.5" fill="#E8A020" opacity="0.9" />
            <rect x="44" y="18" width="3" height="36" rx="1.5" fill="#E8A020" opacity="0.9" />
            <path d="M24 12 Q34 8 44 18" stroke="#E8A020" strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.8" />
            <path d="M24 18 Q34 14 44 24" stroke="#E8A020" strokeWidth="2.5" strokeLinecap="round" fill="none" opacity="0.6" />
            <rect x="49" y="6" width="5" height="18" rx="2.5" fill="#F0C060" opacity="0.95" />
            <rect x="44" y="11" width="15" height="5" rx="2.5" fill="#F0C060" opacity="0.95" />
        </svg>
    ),
};

const CategoryIcon = ({ categoryId, size = 40 }) => {
    const icon = icons[categoryId];
    if (!icon) return null; // Caller should fall back to emoji/image

    return (
        <div style={{ width: size, height: size, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
            {React.cloneElement(icon, { width: size, height: size })}
        </div>
    );
};

export default CategoryIcon;
export { icons };
